const PlacementCard = ({ placement, onApply, isApplied = false }) => {
  const handleClick = () => {
    if (!isApplied) {
      onApply?.(placement.id);
    }
  };

  return (
    <div className="placement-card">
      <div className="placement-head">
        <div className="avatar">{placement.company?.charAt(0)}</div>
        <div>
          <p className="muted small">Hiring now</p>
          <h3>{placement.company}</h3>
        </div>
        <span className="chip chip-soft">{placement.package}</span>
      </div>
      <p className="placement-role">{placement.role}</p>
      <p className="muted">{placement.description}</p>
      <div className="placement-meta">
        <span className="chip chip-outline">{placement.location}</span>
        <button
          type="button"
          onClick={handleClick}
          disabled={isApplied}
          className={isApplied ? "applied-btn" : ""}
        >
          {isApplied ? "Applied" : "Apply"}
        </button>
      </div>
    </div>
  );
};

export default PlacementCard;
